import React, { useState } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const options = ['enabled', 'smart', 'disabled'];
const optionText = {
  enabled: 'Alert the staff member to finish up',
  smart:
    'Alert the staff member, but only if other students are waiting for help',
  disabled: 'Do nothing',
};

export default function TimerActionSelect({ value, onChange }) {
  const [menuAnchor, setMenuAnchor] = useState(null);

  const handleOpenMenu = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleSelectItem = (selectedValue) => () => {
    onChange instanceof Function && onChange(selectedValue);
    setMenuAnchor(null);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  return (
    <>
      <List component="nav">
        <ListItem button onClick={handleOpenMenu}>
          <ListItemText
            primary="When a long interaction occurs,"
            secondary={optionText[value]}
          />
        </ListItem>
      </List>
      <Menu
        anchorEl={menuAnchor}
        keepMounted
        open={Boolean(menuAnchor)}
        onClose={handleCloseMenu}
      >
        {options.map((option) => (
          <MenuItem
            key={option}
            selected={value === option}
            onClick={handleSelectItem(option)}
          >
            {optionText[option]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
